import React, { Component } from "react";
import AdminHoursComponent from './components/AdminHoursComponent';

import PropTypes from 'prop-types';

export class AdminHoursContainer extends Component {
    constructor (props){
        super(props)
        this.state = {

        }

    }

    render(){
        return(
            <AdminHoursComponent />
        )
    }
          
        
}

AdminHoursContainer.defaultProps={

}
AdminHoursContainer.propTypes = {

}

export default(AdminHoursContainer);